/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'

import { checkErrorResponse, checkUpdateResponse, Logger, LoggerTypes } from '../../utils'
import { getProjects, updateProject } from '../../actions'
import { LoaderContext } from '../../contexts'
import { AccessControl, AccessControlNoRights, Page, PageCenter, PageNumSections } from '../../components' // PageRight
// import { ScenarioConsole } from '../../containers/scenarios'
import { ProjectActionsBar } from '../../containers/projects/ProjectActionsBar'
import { ProjectActiveList } from '../../containers/projects/lists/ProjectActiveList'
import { ProjectArchivedList } from '../../containers/projects/lists/ProjectArchivedList'
import { ProjectFavoriteList } from '../../containers/projects/lists/ProjectFavoriteList'
import './style.scss'
import { userRightTypes } from '../../constants'

/**
 * Main component representing the list of projects contained in the DB.
 *
 * @see {ActionsBar}
 * @see {ScenarioConsole}
 * @see {ProjectActiveList}
 * @see {ProjectArchivedList}
 * @returns {Home}
 */
export const Home = () => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const projects = useSelector((state) => state.projects) || {}
  const [isLoading, setIsLoading] = useState(true)

  if (!projects) {
    return
  }

  const items = projects.items || []

  useEffect(() => {
    dispatch(getProjects())
      .then((res) => {
        Logger.trace(LoggerTypes.CONTROLLER, 'Home.useEffect().dispatch().then()', { projects, res })
        // checkSnackbarOK(enqueueSnackbar, t, res)
        setIsLoading(false)
      })
      .catch((res) => {
        Logger.trace(LoggerTypes.WARN, 'Home.useEffect().dispatch().catch()', { projects, res })
        checkErrorResponse(res, enqueueSnackbar, t)
      })
  }, [])

  const onUpdateProject = (projectUpdated) => {
    dispatch(updateProject(projectUpdated))
      .then((res) => {
        Logger.trace(LoggerTypes.CONTROLLER, 'Home.onUpdateProject().dispatch(updateProject).then()', { res })
        checkUpdateResponse(res, enqueueSnackbar, t)
      })
      .catch((res) => {
        Logger.trace(LoggerTypes.WARN, 'Home.onUpdateProject().dispatch(updateProject).catch()', { res })
        checkErrorResponse(res, enqueueSnackbar, t)
      })
  }

  const favorites = Object.values(items).filter((row) => row.favorite === true && row.active === true)
  const actives = Object.values(items).filter((row) => row.active === true)
  const archived = Object.values(items).filter((row) => row.active === false)

  if (!isLoading) {
    Logger.trace(LoggerTypes.PAGE, 'Home.render()', {
      isLoading,
      APP_NAME: process.env.REACT_APP_NAME,
      APP_VERSION: process.env.REACT_APP_VERSION,
      NODE_ENV: process.env.NODE_ENV,
      projects,
      favorites,
      actives,
      archived
    })
  }

  return (
    <Page className="projectList">
      {/* <PageRight>{!isLoading && <ScenarioConsole project={null} />}</PageRight> */}
      <PageCenter numSections={PageNumSections.ONE_SECTION}>
        <ProjectActionsBar />
        <AccessControl userPermissions={[userRightTypes.PROJECT_READ]} renderNoAccess={() => <AccessControlNoRights />}>
          <div className="projectContainer">
            <LoaderContext.Provider value={isLoading}>
              <ProjectFavoriteList favorites={favorites} onUpdateProject={onUpdateProject} />
              <ProjectActiveList actives={actives} onUpdateProject={onUpdateProject} />
              <ProjectArchivedList archived={archived} onUpdateProject={onUpdateProject} />
            </LoaderContext.Provider>
          </div>
        </AccessControl>
      </PageCenter>
    </Page>
  )
}
